import { render, staticRenderFns } from "./BidItem.vue?vue&type=template&id=bc06b888&scoped=true"
import script from "./BidItem.vue?vue&type=script&lang=js"
export * from "./BidItem.vue?vue&type=script&lang=js"
import style0 from "./BidItem.vue?vue&type=style&index=0&id=bc06b888&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc06b888",
  null
  
)

export default component.exports